var L = Object.defineProperty, M = Object.defineProperties;
var U = Object.getOwnPropertyDescriptors;
var i = Object.getOwnPropertySymbols;
var d = Object.prototype.hasOwnProperty, y = Object.prototype.propertyIsEnumerable;
var T = (r, s, e) => s in r ? L(r, s, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[s] = e, R = (r, s) => {
  for (var e in s || (s = {}))
    d.call(s, e) && T(r, e, s[e]);
  if (i)
    for (var e of i(s))
      y.call(s, e) && T(r, e, s[e]);
  return r;
}, S = (r, s) => M(r, U(s));
var j = (r, s) => {
  var e = {};
  for (var o in r)
    d.call(r, o) && s.indexOf(o) < 0 && (e[o] = r[o]);
  if (r != null && i)
    for (var o of i(r))
      s.indexOf(o) < 0 && y.call(r, o) && (e[o] = r[o]);
  return e;
};
import { jsxs as p, jsx as h } from "react/jsx-runtime";
import t from "../../../node_modules/prop-types/index.es.js";
import v, { useState as w, useEffect as z } from "react";
import * as B from "./style.es.js";
import { Progress as H, ProgressHeader as V, ProgressText as X, ProgressRate as Y, ProgressBar as Z } from "./style.es.js";
import { STATUS_COLOR as $ } from "../../../constants/status.es.js";
import { Y_POSITION as E } from "../../../constants/position.es.js";
import { COMPONENT_SIZE as N } from "../../../constants/sizes.es.js";
const k = 100, c = v.forwardRef((D, x) => {
  var P = D, {
    completed: r = !1,
    infoPosition: s = E.top,
    max: e = k,
    showRate: o = !1,
    showText: l = !1,
    size: _ = N.sm,
    status: A,
    text: a,
    timeOut: u = 50,
    value: n
  } = P, I = j(P, [
    "completed",
    "infoPosition",
    "max",
    "showRate",
    "showText",
    "size",
    "status",
    "text",
    "timeOut",
    "value"
  ]);
  const [f, b] = w(0), O = e / 100;
  z(() => {
    let g;
    return f < e - 1 && !r && (g = setTimeout(() => {
      b((C) => C + O);
    }, u)), r === !0 && b(O * 100), () => clearTimeout(g);
  }, [r, f, u]);
  const m = n != null ? n : f;
  return /* @__PURE__ */ p(H, { size: _, status: A, children: [
    (o || l) && /* @__PURE__ */ p(V, { infoPosition: s, children: [
      l && a && /* @__PURE__ */ h(X, { children: a }),
      o && m && /* @__PURE__ */ p(Y, { children: [
        m,
        "%"
      ] })
    ] }),
    /* @__PURE__ */ h(Z, S(R({ value: m, max: e, "aria-describedby": a || "progress-bar", "aria-busy": r }, I), { ref: x }))
  ] });
}), q = {
  completed: t.bool,
  infoPosition: t.oneOf(Object.values(E)),
  max: t.number,
  showRate: t.bool,
  showText: t.bool,
  size: t.oneOf(Object.values(N)),
  status: t.oneOf(Object.values($)),
  text: t.string,
  timeOut: t.number,
  value: t.number
};
c.S = B;
c.displayName = "Progress";
c.propTypes = q;
export {
  c as Progress,
  q as progressPropTypes
};
//# sourceMappingURL=Progress.es.js.map
